/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Thisworkspace1Inputs */

const zh_learn_thisworkspace1 = /** @type {(inputs: Learn_Thisworkspace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这个工作区`)
};

const en_learn_thisworkspace1 = /** @type {(inputs: Learn_Thisworkspace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`this workspace`)
};

const es_learn_thisworkspace1 = /** @type {(inputs: Learn_Thisworkspace1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`este espacio de trabajo`)
};

/**
* | output |
* | --- |
* | "this workspace" |
*
* @param {Learn_Thisworkspace1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_thisworkspace1 = /** @type {((inputs?: Learn_Thisworkspace1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Thisworkspace1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_thisworkspace1(inputs)
	if (locale === "en") return en_learn_thisworkspace1(inputs)
	return es_learn_thisworkspace1(inputs)
});
export { learn_thisworkspace1 as "learn_thisWorkspace" }